import React from 'react';
import { FOOTER_LINKS, SUPPORT_EMAIL } from '../data/config';
export function Footer() {
  return <footer className="bg-slate-950 px-4 py-5 text-center md:px-12" data-id="element-77" data-mp="3gfiugihumbe4">
      <p className="text-[11px] font-extrabold uppercase text-white" data-id="element-78" data-mp="32nulgo2wc31d">
        © 2026 Bright Digital Hub — All Rights Reserved.
      </p>
      <p className="mt-2 text-[11px] font-extrabold uppercase text-white/90" data-id="element-79" data-mp="36qhgexuv642s">Professional Disclaimer</p>
      <div className="mx-auto mt-1 max-w-[640px] space-y-1 text-[12px] leading-[1.4] text-white/70" data-id="element-80" data-mp="3ug3fllb8kjas">
        <p data-id="element-81" data-mp="37o2ul235f8m">
          Complete Postoperative Shoulder Rehabilitation System™ provides specialized educational materials and practical
          resources for physical therapy professionals. It does not replace accredited professional education,
          individualized patient assessment, independent clinical judgment, the treating surgeon's instructions,
          institutional protocols, or current clinical recommendations.
        </p>
        <p data-id="element-82" data-mp="2evx98vvjb8zq">
          Movement and loading permissions must be verified for each patient based on the procedure performed and the
          applicable postoperative restrictions. All clinical content must undergo independent review and validation by
          qualified professionals before distribution for clinical use.
        </p>
      </div>
      <p className="mt-2 text-[12px] font-extrabold text-white" data-id="element-83" data-mp="3q8dhazpl74at">Bright Digital Hub</p>
      <nav aria-label="Legal" className="mt-1 text-[12px] text-white" data-id="element-84" data-mp="82icpt2wkaeu">
        {FOOTER_LINKS.map((l, i) => <React.Fragment key={l.label} data-id="element-85" data-mp="34p6x15ihif3" data-mpi={i}>
            {i > 0 && <span className="mx-1.5" aria-hidden data-id="element-86" data-mp="3232vbhtxl1m">•</span>}
            <a href={l.href} className="transition-colors duration-150 hover:text-amber-400" data-id="element-87" data-mp="hrif7mgm5nxs">
              {l.label}
            </a>
          </React.Fragment>)}
      </nav>
      <p className="mt-1 text-[12px] text-white" data-id="element-88" data-mp="qsqdw5n1kqse">
        Support:{' '}
        <a href={`mailto:${SUPPORT_EMAIL}`} className="underline transition-colors duration-150 hover:text-amber-400" data-id="element-89" data-mp="mrwrjgp8zk1m">
          {SUPPORT_EMAIL}
        </a>
      </p>
    </footer>;
}